module.exports = __webpack_public_path__ + "static/media/login-bg-4.c7d8c058.jpg";